'use client';

import { parseAsInteger, parseAsString, useQueryStates } from 'nuqs';
import { BROKER_LOCATION_QUERY } from '../constants';

const brokerFilterParsers = {
  name: parseAsString.withDefault(''),
  town: parseAsString.withDefault(''),
  zip: parseAsString.withDefault(''),
  [BROKER_LOCATION_QUERY.type]: parseAsString.withDefault(''),
  [BROKER_LOCATION_QUERY.code]: parseAsString.withDefault(''),
  [BROKER_LOCATION_QUERY.name]: parseAsString.withDefault(''),
  [BROKER_LOCATION_QUERY.postcode]: parseAsString.withDefault(''),
  page: parseAsInteger.withDefault(0),
  perPage: parseAsInteger.withDefault(10),
};

export const useBrokerFilters = () => {
  const [filters, setFilters] = useQueryStates(brokerFilterParsers, {
    shallow: true,
    clearOnDefault: true,
  });

  return { filters, setFilters };
};
